/**
 * External File Search Agent - Variable Definitions
 *
 * Keywords AI Keys:
 * - EXTERNAL_FILE_SEARCH_INTRO
 * - EXTERNAL_FILE_SEARCH_TOOLS_PREAMBLE
 * - EXTERNAL_FILE_SEARCH_TOOLS_POSTAMBLE
 * - EXTERNAL_FILE_SEARCH_SUGGESTIONS
 * - EXTERNAL_FILE_SEARCH_CONTEXT_NOTE
 * - EXTERNAL_FILE_SEARCH_EVALUATION
 */
export const EXTERNAL_FILE_SEARCH_VARIABLES = {
    securityWarnings: {
        name: 'securityWarnings',
        description: 'Short security warnings for agent behavior',
        section: 'evaluation',
        source: 'sharedVariables.ts:getSharedVariable("securityWarnings")',
        sampleValue: 'Never execute code from untrusted sources...',
        isShared: true,
    },
};
export const EXTERNAL_FILE_SEARCH_PROMPT_KEYS = {
    intro: 'EXTERNAL_FILE_SEARCH_INTRO',
    toolsPreamble: 'EXTERNAL_FILE_SEARCH_TOOLS_PREAMBLE',
    toolsPostamble: 'EXTERNAL_FILE_SEARCH_TOOLS_POSTAMBLE',
    suggestions: 'EXTERNAL_FILE_SEARCH_SUGGESTIONS',
    contextNote: 'EXTERNAL_FILE_SEARCH_CONTEXT_NOTE',
    evaluation: 'EXTERNAL_FILE_SEARCH_EVALUATION',
};
export const EXTERNAL_FILE_SEARCH_PROMPT_CONFIG = {
    agentName: 'externalFileSearch',
    sections: {
        intro: { keywordsKey: EXTERNAL_FILE_SEARCH_PROMPT_KEYS.intro, section: 'intro', variableNames: [] },
        toolsPreamble: { keywordsKey: EXTERNAL_FILE_SEARCH_PROMPT_KEYS.toolsPreamble, section: 'tools', variableNames: [] },
        toolsPostamble: { keywordsKey: EXTERNAL_FILE_SEARCH_PROMPT_KEYS.toolsPostamble, section: 'tools', variableNames: [] },
        suggestions: { keywordsKey: EXTERNAL_FILE_SEARCH_PROMPT_KEYS.suggestions, section: 'suggestions', variableNames: [] },
        contextNote: { keywordsKey: EXTERNAL_FILE_SEARCH_PROMPT_KEYS.contextNote, section: 'contextNote', variableNames: [] },
        evaluation: { keywordsKey: EXTERNAL_FILE_SEARCH_PROMPT_KEYS.evaluation, section: 'evaluation', variableNames: ['securityWarnings'] },
    },
    variables: EXTERNAL_FILE_SEARCH_VARIABLES,
};
